module.exports = __webpack_public_path__ + "img/bg_footer.d5039830.png";